import { useMemo } from 'react';
import '../../css/LatestSongs.css';
import { SongDisplay } from './SongViews/SongDisplay';
import { Song } from '../../interfaces/userInterfaces';
import { usePublicData } from '../../hooks/usePublicData';

export const LatestSongs: React.FC = () => {
  const { latestSongs } = usePublicData();

  const mapSongArray = (songs: Song[]) => {
    return songs.map((song, i) => {
      return (
        <div key={song.username + i + song.song_id} className="home-song-display">
          <SongDisplay {...song} />
        </div>
      );
    });
  };

  const memoizedSongArray = useMemo(() => mapSongArray(latestSongs), [latestSongs]);

  return <div id="all-songs">{memoizedSongArray}</div>;
};
